const getTime = () => {
  if (typeof window !=='undefined' && typeof performance.now === "function") {
    return window.performance.now()
  }
  return Date.now()
}

export {
  getTime
}